/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Children_TitleInputs */

const fr_guardian_children_title = /** @type {(inputs: Guardian_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enfants`)
};

/**

* @param {Guardian_Children_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_children_title = /** @type {((inputs?: Guardian_Children_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Children_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_children_title(inputs)
});